/* eslint-disable react/require-default-props */
import React from 'react';
import proptypes from 'prop-types';
import { BundleAlertmessage } from '../BundleAlertmessage';

const { shape, string, number } = proptypes;

export const ObsoleteEmptyContainer = ({ bundleProduct, missingProductsCount = 0 }) => {
  const { unavailableAlertMessageText } = bundleProduct?.features || {};

  if (!unavailableAlertMessageText || missingProductsCount <= 0) {
    return null;
  }

  return (
    Array.from({ length: missingProductsCount }).map((__, index) => {
      return (
        <>
          <li
            key={`product-list-${index}`}
            className="product-list-item sui-flex sui-flex-col sui-gap-4"
            data-testid="product-list-item"
          >
            <div className="sui-mb-2">
              <BundleAlertmessage status="error" size="small" content={{ main: unavailableAlertMessageText }} />
            </div>
          </li>
          <hr
            key={`separator-${index}`}
            className="sui-my-4 sui-w-full sui-h-0 sui-border-primary last-of-type:sui-hidden"
          />
        </>
      );
    })
  );
};

ObsoleteEmptyContainer.propTypes = {
  bundleProduct: shape({
    features: shape({
      unavailableAlertMessageText: string
    })
  }).isRequired,
  missingProductsCount: number
};